
const comFooterCarousel = (() => {
  const jsFooterCarousel = (document.getElementById("jsFooterCarousel") != null);
  if (jsFooterCarousel) {


    let sW = window.innerWidth;

    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      slidesPerView = 2.0
      spaceBetween = 80
    } else {
      slidesPerView = 1.2
      spaceBetween = 80
    }

    const swiper = new Swiper("#jsFooterCarousel", {
      loop: true,
      centeredSlides: true,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev"
      }
    });





  }
})();
export default comFooterCarousel;